"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserControllerReSendEmailConfirmation = exports.userControllerReSendEmailConfirmation = exports.useUserControllerConfirmToken = exports.userControllerConfirmToken = exports.useUserControllerUpdateOwnPassword = exports.userControllerUpdateOwnPassword = exports.useUserControllerUpdateOwnProfile = exports.userControllerUpdateOwnProfile = exports.useUserControllerGet = exports.getUserControllerGetQueryKey = exports.userControllerGet = exports.useUserControllerUpdateOwnUserSettings = exports.userControllerUpdateOwnUserSettings = exports.useUserControllerMe = exports.getUserControllerMeQueryKey = exports.userControllerMe = exports.useUserControllerRegister = exports.userControllerRegister = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Exchange I-REC API
 * Swagger documentation for the Exchange I-REC API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const response_type_4 = __importDefault(require("../response-type"));
const response_type_5 = __importDefault(require("../response-type"));
const response_type_6 = __importDefault(require("../response-type"));
const response_type_7 = __importDefault(require("../response-type"));
const response_type_8 = __importDefault(require("../response-type"));
const userControllerRegister = (registerUserDTO) => {
    return (0, response_type_1.default)({ url: `/api/user/register`, method: 'post',
        data: registerUserDTO
    });
};
exports.userControllerRegister = userControllerRegister;
const useUserControllerRegister = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.userControllerRegister)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerRegister = useUserControllerRegister;
const userControllerMe = () => {
    return (0, response_type_2.default)({ url: `/api/user/me`, method: 'get'
    });
};
exports.userControllerMe = userControllerMe;
const getUserControllerMeQueryKey = () => [`/api/user/me`];
exports.getUserControllerMeQueryKey = getUserControllerMeQueryKey;
const useUserControllerMe = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getUserControllerMeQueryKey)();
    const queryFn = () => (0, exports.userControllerMe)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useUserControllerMe = useUserControllerMe;
const userControllerUpdateOwnUserSettings = (updateOwnUserSettingsDTO) => {
    return (0, response_type_3.default)({ url: `/api/user`, method: 'put',
        data: updateOwnUserSettingsDTO
    });
};
exports.userControllerUpdateOwnUserSettings = userControllerUpdateOwnUserSettings;
const useUserControllerUpdateOwnUserSettings = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.userControllerUpdateOwnUserSettings)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerUpdateOwnUserSettings = useUserControllerUpdateOwnUserSettings;
const userControllerGet = (id) => {
    return (0, response_type_4.default)({ url: `/api/user/${id}`, method: 'get'
    });
};
exports.userControllerGet = userControllerGet;
const getUserControllerGetQueryKey = (id) => [`/api/user/${id}`];
exports.getUserControllerGetQueryKey = getUserControllerGetQueryKey;
const useUserControllerGet = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getUserControllerGetQueryKey)(id);
    const queryFn = () => (0, exports.userControllerGet)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useUserControllerGet = useUserControllerGet;
const userControllerUpdateOwnProfile = (updateUserProfileDTO) => {
    return (0, response_type_5.default)({ url: `/api/user/profile`, method: 'put',
        data: updateUserProfileDTO
    });
};
exports.userControllerUpdateOwnProfile = userControllerUpdateOwnProfile;
const useUserControllerUpdateOwnProfile = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.userControllerUpdateOwnProfile)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerUpdateOwnProfile = useUserControllerUpdateOwnProfile;
const userControllerUpdateOwnPassword = (updatePasswordDTO) => {
    return (0, response_type_6.default)({ url: `/api/user/password`, method: 'put',
        data: updatePasswordDTO
    });
};
exports.userControllerUpdateOwnPassword = userControllerUpdateOwnPassword;
const useUserControllerUpdateOwnPassword = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.userControllerUpdateOwnPassword)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerUpdateOwnPassword = useUserControllerUpdateOwnPassword;
const userControllerConfirmToken = (token) => {
    return (0, response_type_7.default)({ url: `/api/user/confirm-email/${token}`, method: 'put'
    });
};
exports.userControllerConfirmToken = userControllerConfirmToken;
const useUserControllerConfirmToken = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { token } = props || {};
        return (0, exports.userControllerConfirmToken)(token);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerConfirmToken = useUserControllerConfirmToken;
const userControllerReSendEmailConfirmation = () => {
    return (0, response_type_8.default)({ url: `/api/user/re-send-confirm-email`, method: 'put'
    });
};
exports.userControllerReSendEmailConfirmation = userControllerReSendEmailConfirmation;
const useUserControllerReSendEmailConfirmation = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = () => {
        ;
        return (0, exports.userControllerReSendEmailConfirmation)();
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useUserControllerReSendEmailConfirmation = useUserControllerReSendEmailConfirmation;
//# sourceMappingURL=user.js.map